module.exports = __webpack_public_path__ + "img/image_2.160e76c0.jpg";